import { data } from 'hudl-base';
import { getConsentState } from '../consent-utils';

window.googletag = window.googletag || {};
const googletag = window.googletag;
googletag.cmd = googletag.cmd || [];

// Backend may require non-personalized ads regardless of consent (e.g., underage users).
// This is a floor — consent can only add restrictions, never remove the backend's restriction.
const adData = data.get('ads');
const backendRequiresNpa = adData?.targetingData?.nonPersonalizedAds === 'True';

/**
 * Updates GAM privacy settings based on targeting consent.
 * Must be called BEFORE refresh() for the setting to take effect.
 * @param {boolean} hasTargetingConsent - Whether user has granted targeting consent (C0004)
 */
function updateGamPrivacySettings(hasTargetingConsent) {
  googletag.cmd.push(() => {
    googletag.pubads().setPrivacySettings({
      nonPersonalizedAds: backendRequiresNpa || !hasTargetingConsent,
      // CCPA: restricts how Google processes data on their backend, beyond just ad personalization.
      // nonPersonalizedAds alone does not satisfy CCPA opt-out obligations.
      // https://support.google.com/admanager/answer/9598414
      restrictDataProcessing: backendRequiresNpa || !hasTargetingConsent,
    });
  });
}

// Set initial privacy settings by waiting for __consentState
getConsentState().then(consentState => {
  updateGamPrivacySettings(consentState.hasTargeting);
});

// Listen for ongoing consent changes (re-dispatched by _ConsentScriptLoader on HudlConsentUpdated)
window.addEventListener('ConsentScriptsReady', () => {
  if (window.__consentState) {
    updateGamPrivacySettings(window.__consentState.hasTargeting);
  }
});

googletag.cmd.push(() => {
  googletag.pubads().disableInitialLoad();
  googletag.enableServices();
});
